<template>
  <v-dialog
    v-model="addEventDialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-toolbar
      dark
      fixed
      color="secondary"
    >
      <v-btn
        icon
        dark
        @click.native="addEventDialog = false"
      >
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>אירוע חדש</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        dark
        flat
        large
        :loading="adding"
        :disabled="adding"
        @click.native="addEvent"
      >
        שמירה
      </v-btn>
    </v-toolbar>
    <v-card>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-layout
          row
          wrap
        >
          <v-flex class="xs12 lg6">
            <v-card-text>
              <!-- Event details -->
              <v-container
                fluid
                grid-list-md
                class="mt-5"
              >
                <div class="headline mb-2">פרטי האירוע</div>
                <v-layout
                  row
                  wrap
                >
                  <v-flex
                    xs12
                    sm6
                  >
                    <v-text-field
                      type="datetime-local"
                      v-model="startDate"
                      label="זמן התחלה *"
                    ></v-text-field>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                  >
                    <v-combobox
                      v-model="type"
                      :rules="typeRules"
                      :items="types"
                      item-text="title"
                      item-value="_id"
                      label="סוג אירוע *"
                    >
                      <template
                        slot="selection"
                        slot-scope="{ item, index }"
                      >
                        {{ item.title }}
                      </template>
                    </v-combobox>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                  >
                    <v-combobox
                      v-model="source"
                      :rules="sourceRules"
                      :items="sources"
                      item-text="title"
                      item-value="_id"
                      label="מקור אירוע *"
                    >
                      <template
                        slot="selection"
                        slot-scope="{ item, index }"
                      >
                        {{ item.title }}
                      </template>
                    </v-combobox>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                  >

                    <v-autocomplete
                      v-model="country"
                      :rules="countryRules"
                      :items="countries"
                      item-text="name"
                      item-value="_id"
                      label="מדינה *"
                    >
                      <template
                        slot="selection"
                        slot-scope="{ item, index }"
                      >
                        {{ item.name }}
                      </template>
                    </v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-container
                fluid
                grid-list-md
              >
                <div class="headline mb-2">צוות</div>
                <v-layout
                  row
                  wrap
                >
                  <v-flex
                    xs12
                    sm6
                  >
                    <v-combobox
                      v-model="eventManager"
                      :rules="managerRules"
                      :items="managers"
                      item-text="name"
                      item-value="_id"
                      label="מנהל/ת האירוע *"
                    >
                      <template
                        slot="selection"
                        slot-scope="{ item, index }"
                      >
                        {{ item.name }}
                      </template>
                    </v-combobox>
                  </v-flex>
                </v-layout>
              </v-container>

              <!-- Inreach -->
              <v-container
                fluid
                grid-list-md
              >
                <div class="headline mb-2">מכשיר אינריץ׳ (שלנו בלבד)</div>
                <v-layout
                  row
                  wrap
                >
                  <v-flex
                    xs12
                    sm8
                  >
                    <v-text-field
                      v-model="imei"
                      label="IMEI"
                      placeholder=""
                    ></v-text-field>
                  </v-flex>
                  <v-flex
                    xs12
                    sm4
                  >
                    <v-btn
                      block
                      depressed
                      :loading="fetchingCustomerData"
                      :disabled="fetchingCustomerData"
                      @click="fetchCustomerData"
                    >הזנת פרטי מחולץ אוטו׳</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>

              <!-- Customer -->
              <v-container
                fluid
                grid-list-md
              >
                <div class="headline mb-2">פרטי מחולץ</div>
                <v-layout
                  row
                  wrap
                >
                  <v-flex
                    xs12
                    sm6
                  >
                    <v-text-field
                      v-model="customerData.name"
                      label="שם מלא *"
                      :rules="nameRules"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                  >
                    <v-text-field
                      v-model="customerData.id"
                      label="תעודת זהות"
                    ></v-text-field>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                  >
                    <v-text-field
                      v-model="customerData.age"
                      label="גיל *"
                      type="number"
                      min="0"
                      :rules="ageRules"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                  >
                    <v-select
                      v-model="customerData.gender"
                      :items="genders"
                      item-text="title"
                      item-value="_id"
                      :rules="genderRules"
                      label="מין *"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                  >
                    <v-combobox
                      v-model="customerData.insuranceCompany"
                      :rules="insuranceCompanyRules"
                      :items="sortedInsuranceCompanies"
                      item-text="name"
                      item-value="_id"
                      label="חברת ביטוח"
                    >
                      <template
                        slot="selection"
                        slot-scope="{ item, index }"
                      >
                        {{ item.name }}
                      </template>
                    </v-combobox>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                  >
                    <v-text-field
                      v-model="customerData.policyNumber"
                      :rules="policyNumberRules"
                      label="מספר פוליסה"
                    ></v-text-field>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                  >

                   <v-text-field
                      v-model="customerData.nameEn"
                      label="מספר טלפון"
                    ></v-text-field>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                  >


                    <v-combobox
                      v-model="customerData.sar"
                      :rules="sarCoverageRules"
                      :items="sarOptions"
                      item-text="text"
                      item-value="value"
                      label="כיסוי איתור וחילוץ"
                      return-object
                      @change="handleSarChange"
                    >
                      <template slot="selection" slot-scope="{ item }">
                        {{ item.text }}
                      </template>
                    </v-combobox>
                  </v-flex>
                </v-layout>
              </v-container>

              <!-- ARAN -->
              <v-container
                fluid
                grid-list-md
              >
                <div class="headline mb-2">אר"ן</div>
                <v-layout
                  row
                  wrap
                >
                                    <v-flex
                    xs12
                  >
                    <v-radio-group
                      v-model="aranOption"
                      class="mb-3"
                      @change="onAranOptionChange"
                    >
                      <v-radio
                        label="ללא ארן"
                        value="none"
                        class="mb-2"
                      ></v-radio>
                      <v-radio
                        label="ארן חדש"
                        value="new"
                        class="mb-2"
                      ></v-radio>
                      <v-radio
                        label="הוספה לארן קיים"
                        value="existing"
                        class="mb-2"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    v-if="aranOption === 'new'"
                  >
                    <v-text-field
                      v-model="newAranName"
                      label="שם ארן חדש"
                      placeholder="הזן שם ארן חדש"
                      outlined
                      dense
                    ></v-text-field>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    v-if="aranOption === 'existing'"
                  >
                    <v-autocomplete
                      v-model="selectedAran"
                      :items="arans"
                      item-text="name"
                      item-value="_id"
                      label="בחר ארן קיים"
                      :loading="loadingArans"
                      :disabled="loadingArans"
                      outlined
                      dense
                    >
                      <template
                        slot="selection"
                        slot-scope="{ item, index }"
                      >
                        {{ item.name }}
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <!-- Debug info -->
                  <v-flex xs12 v-if="aranOption">
                    <small class="text-muted">Debug: Selected option: {{ aranOption }}</small>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-container
                fluid
                grid-list-md
              >
                <v-layout
                  row
                  wrap
                >
                  <v-flex
                    xs12
                    sm6
                  >
                    <v-btn
                      color="secondary"
                      :loading="adding"
                      :disabled="adding"
                      @click.native="addEvent"
                    >שמירה</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-actions>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { format } from "date-fns";
import generateId from "@/idGenerator";
import { getApi } from "@/api";
export default {
  data() {
    return {
      adding: false,
      fetchingCustomerData: false,

      contact1Id: null,
      contact2Id: null,
      customerId: null,
      eventId: null,
      dutyId: null,

      // Form data
      startDate: null,
      eventManager: null,
      type: null,
      country: null,
      insuranceCompany: null,
      policyNumber: null,
      // sarCoverage: null,
      // customerName: "",
      source: null,
      imei: "",

      customerData: {
        name: "",
        nameEn: "",
        age: null,
        gender: null,
        phone: null,
        id: null,
        passport: null,
        description: null,
        insuranceCompany: null,
        policyNumber: null,
        sar: null,
        mobilePhone: null,
        email: null
      },

      contacts: [],

      // Form validation
      valid: true,
      nameRules: [v => !!v || "חובה להזין שם"],
      countryRules: [v => !!v || "חובה לבחור מדינה"],
      typeRules: [v => !!v || "חובה לבחור סוג אירוע"],
      sourceRules: [v => !!v || "חובה לבחור מקור אירוע"],
      managerRules: [v => !!v || "חובה לבחור מנהל אירוע"],
      ageRules: [
        v =>
          (v !== null &&
            v !== undefined &&
            v !== "" &&
            Number(v) > 0) ||
          "חובה להזין גיל תקין"
      ],
      genderRules: [v => !!v || "חובה לבחור מין"],
      insuranceCompanyRules: [],
      policyNumberRules: [],
      sarCoverageRules: [],
      idRules: [],
      sarOptions: [
        { value: true, text: 'כן' },
        { value: false, text: 'לא' }
      ],

      // ARAN data
      aranOption: 'none',
      newAranName: '',
      selectedAran: null,
      arans: [],
      loadingArans: false,
      eventAranId: null,
    };
  },

  computed: {
    addEventDialog: {
      get() {
        return this.$store.getters["events/addEventDialog"];
      },
      set(isActive) {
        this.$store.commit("events/TOGGLE_ADD_EVENT_DIALOG", isActive);
      }
    },
    user() {
      return this.$store.getters["user/user"];
    },
    managers() {
      return this.$store.getters["eventsManagers"];
    },
    genders() {
      return this.$store.getters["entityList"]("genders");
    },
    types() {
      const excluded = [
        'העברה לטיפול צוות אחר',
        'סיוע לרכב תקוע',
        'מנותק קשר',
        'אסון טבע',
        'אר"ן',
        'מצב רפואי הדורש פינוי',
        'רפואי נפשי'
      ];
      return this.$store.getters["entityList"]("eventTypes").filter(
        t => !excluded.includes(t.title)
      );
    },
    sources() {
      return this.$store.getters["entityList"]("eventSources");
    },
    insuranceCompanies() {
      return this.$store.getters["entityList"]("insuranceCompanies");
    },
    countries() {
      return this.$store.getters["entityList"]("countries").filter(item => {
        return item.isActive;
      });
    },
    selectedCountry() {
      return this.$store.state.entities.countries[this.country];
    },
    customer() {
      let customer = {
        _id: this.customerId,
        insuranceCompany: this.customerData.insuranceCompany,
        policyNumber: this.customerData.policyNumber,
        sar: this.customerData.sar || false,
        name: this.customerData.name,
        nameEn: this.customerData.nameEn,
        id: this.customerData.id,
        passport: this.customerData.passport,
        phone: this.customerData.phone,
        description: this.customerData.description,
        age:
          this.customerData.age !== null && this.customerData.age !== ""
            ? Number(this.customerData.age)
            : null,
        gender: this.customerData.gender,
        event: this.eventId,
        imei: this.imei
      };
      return customer;
    },
    event() {
      let event = {
        _id: this.eventId,
        title: `${this.customerData.name}, ${
          this.selectedCountry ? this.selectedCountry.name : ""
        }`,
        startDate: new Date(this.startDate),
        countries: [this.selectedCountry],
        type: this.type,
        source: this.source,
        mainCustomer: this.customerId
      };
      
      // Add ARAN ID if available
      if (this.eventAranId) {
        event.aran = this.eventAranId;
      }
      
      return event;
    },
    duty() {
      let duty = {
        _id: this.dutyId,
        event: this.eventId,
        startDate: new Date(this.startDate),
        user: this.eventManager,
        role: this.eventManagerRoleId
      };
      return duty;
    },
    eventManagerRoleId() {
      let role = Object.values(this.$store.state.entities.roles).find(item => {
        return item.key === 'EVENT_MANAGER';
      })
      return role ? role._id : null;
    },
    sortedInsuranceCompanies() {
      return [...this.insuranceCompanies].sort((a, b) => {
        // Sort by order descending
        return (b.order || 0) - (a.order || 0);
      });
    }
  },

  methods: {
    addEntity(resource) {
      // return new Promise((resolve, reject) => {
      //   let entity, schema, listSchema, entityId, entityType, url, isNew;
      //   url = resource.endpoint;
      //   entityType = resource.entityType;
      //   schema = "contactSchema";
      //   listSchema = resource.listSchema;
      //   entityId = this.contactId;
      //   entity = this.contact(1);
      //   isNew = true;
      //   if (entity) {
      //     return this.$store.dispatch("SAVE_ENTITY", {
      //       url,
      //       entityType,
      //       schema,
      //       listSchema,
      //       entityId,
      //       entity,
      //       isNew
      //     });
      //   }
      // });
    },
    contactDetail(index) {
      if (
        this.contacts &&
        this.contacts[index] &&
        this.contacts[index].mobile
      ) {
        let contactDetail = {
          contact: this["contact" + (index + 1) + "Id"],
          data: this.contacts[index].mobile
        };
        return contactDetail;
      } else {
        return null;
      }
    },
    customerContactDetail(key) {
      if (this.customerData && this.customerData[key]) {
        let contactDetail = {
          customer: this.customerId,
          data: this.customerData[key],
          description: key
        };
        return contactDetail;
      } else {
        return null;
      }
    },
    contact(index) {
      if (
        this.contacts &&
        this.contacts[index] &&
        this.contacts[index].mobile
      ) {
        let contact = {
          _id: this["contact" + (index + 1) + "Id"],
          event: this.eventId,
          name: this.contacts[index].name,
          description: `${this.contacts[index].relation ||
            "קרבה לא ידועה"} של ${this.customerData.name || "מחולצ/ת"}`
        };
        return contact;
      } else {
        return null;
      }
    },
    addEvent() {
      if (this.$refs.form.validate()) {
        this.adding = true;

        this.contact1Id = generateId();
        this.contact2Id = generateId();
        this.customerId = generateId();
        this.eventId = generateId();
        this.dutyId = generateId();

        // Handle ARAN creation/selection first
        let aranPromise = Promise.resolve(null);
        
        if (this.aranOption === 'new' && this.newAranName) {
          // Create new ARAN
          aranPromise = getApi()
            .then(api => {
              return api.post("/aran", {
                name: this.newAranName
              });
            })
            .then(({ data }) => {
              console.log('New ARAN created:', data);
              return data._id; // Return the new ARAN ID
            })
            .catch(err => {
              console.log('Error creating ARAN:', err);
              this.$store.dispatch("SHOW_SNACKBAR", {
                text: err.response ? err.response.data.message : err.message,
                color: "error"
              });
              throw err;
            });
        } else if (this.aranOption === 'existing' && this.selectedAran) {
          // Use existing ARAN ID
          aranPromise = Promise.resolve(this.selectedAran);
        }

        // Continue with event creation after ARAN handling
        aranPromise
          .then(aranId => {
            // Store the ARAN ID for use in event creation
            this.eventAranId = aranId;
            
            return this.$store.dispatch("CLEAR_CACHE");
          })
          .then(() => {
            let entity, schema, listSchema, entityId, entityType, url, isNew;

            url = "events";
            entityType = "events";
            schema = "eventSchema";
            listSchema = "eventListSchema";
            entityId = this.event._id;
            entity = this.event;
            isNew = true;

            return this.$store.dispatch("SAVE_ENTITY", {
              url,
              entityType,
              schema,
              listSchema,
              entityId,
              entity,
              isNew
            });
          })
          .then(() => {
            let entity, schema, listSchema, entityId, entityType, url, isNew;

            url = "duties";
            entityType = "duties";
            schema = "dutySchema";
            listSchema = "dutyListSchema";
            entityId = this.dutyId;
            entity = this.duty;
            isNew = true;

            return this.$store.dispatch("SAVE_ENTITY", {
              url,
              entityType,
              schema,
              listSchema,
              entityId,
              entity,
              isNew
            });
          })
          .then(() => {
            let entity, schema, listSchema, entityId, entityType, url, isNew;

            url = "customers";
            entityType = "customers";
            schema = "customerSchema";
            listSchema = "customerListSchema";
            entityId = this.customerId;
            entity = this.customer;
            isNew = true;

            return this.$store.dispatch("SAVE_ENTITY", {
              url,
              entityType,
              schema,
              listSchema,
              entityId,
              entity,
              isNew
            });
          })
          .then(() => {
            let entity, schema, listSchema, entityId, entityType, url, isNew;

            url = "contacts";
            entityType = "contacts";
            schema = "contactSchema";
            listSchema = "contactListSchema";
            entityId = this.contactId;
            entity = this.contact(0);
            isNew = true;

            if (entity) {
              return this.$store.dispatch("SAVE_ENTITY", {
                url,
                entityType,
                schema,
                listSchema,
                entityId,
                entity,
                isNew
              });
            }
          })
          .then(() => {
            let entity, schema, listSchema, entityId, entityType, url, isNew;

            url = "contacts";
            entityType = "contacts";
            schema = "contactSchema";
            listSchema = "contactListSchema";
            entityId = this.contactId;
            entity = this.contact(1);
            isNew = true;

            if (entity) {
              return this.$store.dispatch("SAVE_ENTITY", {
                url,
                entityType,
                schema,
                listSchema,
                entityId,
                entity,
                isNew
              });
            }
          })
          .then(() => {
            let entity, schema, listSchema, entityId, entityType, url, isNew;

            url = "contact-details";
            entityType = "contactDetails";
            schema = "contactDetailSchema";
            listSchema = "contactDetailListSchema";
            entityId = this.contactDetailId;
            entity = this.customerContactDetail("mobilePhone");
            isNew = true;

            if (entity) {
              return this.$store.dispatch("SAVE_ENTITY", {
                url,
                entityType,
                schema,
                listSchema,
                entityId,
                entity,
                isNew
              });
            }
          })
          .then(() => {
            let entity, schema, listSchema, entityId, entityType, url, isNew;

            url = "contact-details";
            entityType = "contactDetails";
            schema = "contactDetailSchema";
            listSchema = "contactDetailListSchema";
            entityId = this.contactDetailId;
            entity = this.customerContactDetail("email");
            isNew = true;

            if (entity) {
              return this.$store.dispatch("SAVE_ENTITY", {
                url,
                entityType,
                schema,
                listSchema,
                entityId,
                entity,
                isNew
              });
            }
          })
          .then(() => {
            let entity, schema, listSchema, entityId, entityType, url, isNew;

            url = "contact-details";
            entityType = "contactDetails";
            schema = "contactDetailSchema";
            listSchema = "contactDetailListSchema";
            entityId = this.contactDetailId;
            entity = this.contactDetail(0);
            isNew = true;

            if (entity) {
              return this.$store.dispatch("SAVE_ENTITY", {
                url,
                entityType,
                schema,
                listSchema,
                entityId,
                entity,
                isNew
              });
            }
          })
          .then(() => {
            let entity, schema, listSchema, entityId, entityType, url, isNew;

            url = "contact-details";
            entityType = "contactDetails";
            schema = "contactDetailSchema";
            listSchema = "contactDetailListSchema";
            entityId = this.contactDetailId;
            entity = this.contactDetail(1);
            isNew = true;

            if (entity) {
              return this.$store.dispatch("SAVE_ENTITY", {
                url,
                entityType,
                schema,
                listSchema,
                entityId,
                entity,
                isNew
              });
            }
          })
          .then(() => {
            // After all entities are saved, trigger Google Sheets update
            // by updating the event (this should trigger backend to update Google Sheets with all customer data)
            if (this.eventAranId) {
              return getApi()
                .then(api => {
                  // Fetch the event to get the latest data
                  return api.get(`/events/${this.eventId}`);
                })
                .then(({ data }) => {
                  // Update the event to trigger Google Sheets sync
                  // The backend should detect this and update Google Sheets with all customers
                  return getApi().then(api => {
                    return api.put(`/events/${this.eventId}`, {
                      ...data,
                      // Force update to trigger Google Sheets sync
                      _triggerGoogleSheetsUpdate: true
                    });
                  });
                })
                .catch(err => {
                  console.log('Error triggering Google Sheets update:', err);
                  // Don't fail the whole operation if this fails
                });
            }
          })
          .then(() => {
            this.addEventDialog = false;
          })
          .catch(err => {
            console.log(err);
            this.$store.dispatch("SHOW_SNACKBAR", {
              text: err.message,
              color: "error"
            });
          })
          .finally(() => {
            this.adding = false;
          });
      }
    },
    reset() {
      this.startDate = null;
      this.eventManager = null;
      this.type = null;
      this.country = null;
      this.insuranceCompany = null;
      this.policyNumber = null;
      this.sarCoverage = null;
      
      // Reset ARAN fields
      this.aranOption = 'none';
      this.newAranName = '';
      this.selectedAran = null;
      this.eventAranId = null;
      
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
    },
    fetchCustomerData() {
      this.fetchingCustomerData = true;
      getApi()
        .then(api => {
          let params = { imei: this.imei };
          return api.get("/sat/get-customer-details-by-imei", { params });
        })
        .then(({ data }) => {
          this.contacts = data.contacts;
          this.customerData.name = data.name;
          this.customerData.nameEn = data.nameEn;
          this.customerData.id = data.id;
          this.customerData.mobilePhone = data.mobilePhone;
          this.customerData.email = data.email;
          this.customerData.policyNumber = data.insurance.policyNumber;
          this.customerData.insuranceCompany = this.insuranceCompanyByName(
            data.insurance.companyName
          );
        })
        .catch(err => {
          console.log(err);
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.response ? err.response.data.message : err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.fetchingCustomerData = false;
        });
    },
    insuranceCompanyByName(name) {
      let company = this.insuranceCompanies.find(item => {
        return item.name === name;
      });
      return company;
    },
    handleSarChange(item) {
      this.customerData.sar = item ? item.value : false;
    },
    fetchArans() {
      this.loadingArans = true;
      getApi()
        .then(api => {
          return api.get("/aran");
        })
        .then(({ data }) => {
          // Handle the response structure with results array
          this.arans = data.results || data;
          console.log('Fetched ARANs:', this.arans);
        })
        .catch(err => {
          console.log(err);
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.response ? err.response.data.message : err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.loadingArans = false;
        });
    },
    onAranOptionChange(value) {
      console.log('ARAN option changed to:', value);
      this.$set(this, 'aranOption', value);
    }
  },

  beforeMount() {},

  mounted() {
    // If this user is a manager, use him as default event manager
    if (this.user._id) {
      if (
        this.managers.findIndex(item => {
          return item._id === this.user._id;
        }) !== -1
      ) {
        this.eventManager = this.user;
      }
    }
  },

  watch: {
    addEventDialog: {
      handler: function(val) {
        if (!val) {
          this.reset();
        } else {
          this.startDate =
            format(new Date(), "YYYY-MM-DD") +
            "T" +
            format(new Date(), "HH:mm");
        }
      },
      immediate: true
    },
    aranOption: {
      handler: function(newVal) {
        console.log('ARAN option watcher triggered:', newVal);
        if (newVal === 'existing' && this.arans.length === 0) {
          this.fetchArans();
        }
      },
      immediate: true
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/events/AddEventDialog.vue